module.exports = __webpack_public_path__ + "img/forum_tech_Normal_ua.415684e4.webp";